import { useState } from 'react'

import { useAuth0 } from 'shim/auth0-react'

import { DELETE_USER_API_TOKENS } from '../queries'
import { consoleFetcher } from 'common/fetchers/graphql'

interface ApiKeyDeletionData {
  loading: boolean
  err: null | Error
  data: boolean
}

export default function useDeleteApiKeys() {
  const { getAccessTokenSilently } = useAuth0()

  const [requestState, setRequestState] = useState<ApiKeyDeletionData>({
    loading: false,
    err: null,
    data: false,
  })
  const deleteApiKeys = async (ids: string[]) => {
    setRequestState({
      data: false,
      loading: true,
      err: null,
    })

    try {
      const response = await consoleFetcher(
        DELETE_USER_API_TOKENS,
        {
          id: ids,
        },
        { tokenFn: getAccessTokenSilently }
      )

      if (!response.deleteUserAPITokens) throw new Error('The API returned an invalid response.')

      setRequestState({
        loading: false,
        err: null,
        data: true,
      })
    } catch (error) {
      setRequestState({
        loading: false,
        err: error as Error,
        data: false,
      })
    }
  }

  return { deleteApiKeys, err: requestState.err, loading: requestState.loading, data: requestState.data }
}
